import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { mergeMap, take } from 'rxjs/operators';
import { LanguagesService } from '@app/i18n';
import { SKIP_LANGUAGE } from '../http-context';

export const acceptLanguageInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_LANGUAGE)) {
        return next(request);
    }
    const languagesService = inject(LanguagesService);
    return languagesService.getUserLanguage$.pipe(
        take(1),
        mergeMap((language: string) =>
            next(
                request.clone({
                    headers: request.headers.set('Accept-Language', language),
                }),
            ),
        ),
    );
};
